import router from './router';
import getPageTitle from '@/get-page-title';

// 白名单， 这个里面的可以不用登录直接进入
const whiteList = ['/'];

router.beforeEach((to, from, next) => {
    let token = localStorage.getItem('token');
    document.title = getPageTitle(to.meta.title);
    if (token) {
        if (to.path === '/') {
            next({ path: '/home/company' });
        } else {
            next();
        }
    } else {
        // 在免登录白名单，直接进入
        if (whiteList.indexOf(to.path) !== -1) {
            next();
        } else {
            next(`/?redirect=${to.path}`); // 否则全部重定向到登录页
        }
    }
});

// router.afterEach(() => {
// });
